import { computed, ref, useContext, useRoute, useRouter } from '@nuxtjs/composition-api'
import { UseRedirectToCorrectUrl } from './types'
import { createProductPath } from '~/modules/product-correct-url/helpers'
import { Product } from '~/modules/catalog/product/types'
import { getSlug } from '~/modules/catalog/product/getters/productGetters'

export function useRedirectToCorrectUrl (): UseRedirectToCorrectUrl {
  const route = useRoute()
  const router = useRouter()
  const ctx = useContext()
  const product = ref<Product>(null)

  const { slug, id } = route.value.params
  const correctSlug = computed<string>(() => product.value ? getSlug(product.value) : '')

  function setRedirectedProduct (newProduct: Product): void {
    product.value = newProduct
  }

  function urlHasExpectedSlug (): boolean {
    return `/${slug}` === correctSlug.value
  }

  function redirectToCorrectUrl (): boolean {
    if (process.server && !urlHasExpectedSlug()) {
      ctx.redirect(301, router.resolve(createProductPath(id, correctSlug.value)).href)
      return true
    }

    return false
  }

  return {
    redirectToCorrectUrl,
    setRedirectedProduct
  }
}
